import * as React from "react";
import { ColorPicker, Label } from "uxp/components";
import { IBaseProperty, IUIPropertyDefinition } from '../common';
import { CustomColorPicker } from "./common";

interface IColorProperty extends IBaseProperty {
    color: string;
}

export function ColorProperty(title: string, props: IColorProperty): IUIPropertyDefinition<IColorProperty> {
    return {
        defaults: props,
        render: (props) => {
            return <div className='wd-prop-item'>
                <div className='wd-prop-item-title'>{title}</div>
                <div className='wd-prop-item-editor'>
                    <Label>Color</Label>

                    <CustomColorPicker contextData={props.contextData}
                        color={props.uiProps.color || ''}
                        onChange={s => props.onChange(Object.assign({}, props.uiProps, { color: s }))}
                    />
                </div>
            </div>;
        }
    };
}
export function SimpleColorProperty(title: string, color: string): IUIPropertyDefinition<string> {
    return {
        defaults: color,
        render: (props) => {
            return <div className='wd-prop-item'>
                <div className='wd-prop-item-title'>{title}</div>
                <div className='wd-prop-item-editor'>
                    <Label>Color</Label>

                    <CustomColorPicker contextData={props.contextData}
                        color={props.uiProps || ''}
                        onChange={s => props.onChange(s)}
                    />
                </div>
            </div>;
        }
    };
}